import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import AdminEditCompetencyDisplay from './AdminEditCompetencyDisplay';

class AdminCompetencyEdit extends Component{
	constructor(props) {
    super(props)
    this.state = {
        formOpen: false,
        mainParentFormOpen: false,
        errorMsg: '',
        mainSelectionBoxErrorMsg: '',
        selectedRoadmap: '',
    	data:{
    		'roadmapId' : '',
    		'competencyName' : '',
        'competencyDesc' : ''
    	},
      mainSelectionBox:{
        'competencyId' : ''
      },
    	manageData: {
    		'competencyDetails':[]
    	}
    };
  }

  handleMainParentFormOpen = (event) => {
    this.setState({mainParentFormOpen: true, mainSelectionBoxErrorMsg:''})
  }

  handleMainParentFormClose = (event) => {
    let defaultSelectionBox = Object.assign({}, this.state.mainSelectionBox)
    defaultSelectionBox.competencyId = ''
    this.setState({mainSelectionBox: defaultSelectionBox, mainParentFormOpen: false})
  }

  handleMainParentChange = (event) => {
    let mainSelectionBox = Object.assign({}, this.state.mainSelectionBox)
    mainSelectionBox.competencyId = event.target.value
    this.setState({mainSelectionBox: mainSelectionBox})
  }

  saveMainParent = (event) => {
    let mainSelectionBox = Object.assign({}, this.state.mainSelectionBox)

    if(mainSelectionBox.competencyId == ''){
      return this.setState({ mainSelectionBoxErrorMsg: 'Please select a Parent Comptency. ' })
    }
    let input = {
      'competency_id' : mainSelectionBox.competencyId
    }
    api.adminCompetencySetMainFlow(this.props.user.accessToken, this.state.mainSelectionBox.competencyId)
      .then((result) => {
        if(result.status == 'success') {
          this.setState({mainParentFormOpen: false})
        }
      })
  }

  handleComptencyPageReturn = (event) => {
    this.props.handleCompetencyPageBackAction(this.props.user.accessToken)
  }

  componentDidMount() {
    let manageData = Object.assign({}, this.state.manageData)

    let selectedRoadmapVar = this.props.roadmapId

    return api.adminCompetencyDisplay(this.props.user.accessToken, this.props.roadmapId)
    .then((result) => {
      manageData.competencyDetails = result.data
      this.setState({manageData: manageData, selectedRoadmap: selectedRoadmapVar})
    })
  }

  render() {
    let mainParentCompoenent
    let competenciesToShow

    if (this.state.mainParentFormOpen) {
      mainParentCompoenent = (
        <GridCell span="4">
            <Select
              name="competency"
              onChange={this.handleMainParentChange}
              value={this.state.mainSelectionBox.competencyId}
              className="select-component"
              placeholder="--Select Parent--">
              {this.state.manageData.competencyDetails.map(comps => (
                <option key={comps.id} value={comps.id} data-name={comps.name}>
                  {comps.name}
                </option>
              ))}
            </Select>
            <br />
            <span>
            <Button raised style={{ width: '50%' }} onClick={this.saveMainParent}>Save</Button>
            <Button style={{ width: '50%' }} onClick={this.handleMainParentFormClose}>Cancel</Button>
            </span>
            <StatusMessage error_msg = {this.state.mainSelectionBoxErrorMsg} />
        </GridCell>
      )
    }

    if (this.state.manageData.competencyDetails.length>0){
      let selectedRoadmap = this.state.selectedRoadmap
      competenciesToShow = (
        <div>

          {this.state.manageData.competencyDetails.map(function(competencyDetail){
            return (
                <AdminEditCompetencyDisplay competencyId = {competencyDetail.id}
                  competencyName= {competencyDetail.name}
                  roadmapId= {selectedRoadmap} />
            )
          })}
        </div>
      )
    }
    return (
    	<div>
        <Grid>
          <GridCell span="4">
            <Button raised style={{width: '25%'}} onClick={this.handleComptencyPageReturn}>Back</Button>
          </GridCell>
          <GridCell span="12">
            <form style={{width: '100%'}}>
              <Card style={{padding: '25px'}}>
                <Typography use="headline5">Roadmap Edit</Typography>
              </Card>
            </form> 
          </GridCell>
          <GridCell span="5">
            <Button raised onClick={this.handleMainParentFormOpen}>Set Main Parent</Button>
            <GridCell span="6">
                {mainParentCompoenent}
              </GridCell>
          </GridCell>
          <GridCell span="11">
            <Card style={{padding: '25px', backgroundcolor: 'wheat'}}>
              <form style={{width: '100%'}}>
                <GridCell span="8">
                  <Typography use="subtitle1">List of Competencies</Typography>             
                </GridCell>
                {competenciesToShow}
              </form>
            </Card>
          </GridCell>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCompetencyEdit);




// WEBPACK FOOTER //
// ./src/views/admin/AdminCompetencyEdit.jsx